<div class="search-area-wrapper">
  <div class="search-preffix" [ngClass]="loading ? 'loading' : 'search'">
    <input [formControl]="searchControl" (keydown.escape)="cleanSearch()"
           [class.filtering]="isFiltering && !loading && !isSearchPage"
           [readonly]="loading"
           [nzSize]="(screenService.isMobile$ | async) ? 'default' : 'large'" type="text" nz-input
           class="global-searchbar"
           placeholder="Busca referencias, contenedores, BLs, proyectos, servicios..."/>
    @if (searchControl.value) {
      <app-st-icon style="z-index: 515" (click)="cleanSearch()" class="clean-preffix" name="close"></app-st-icon>
    }
  </div>

  @if (isFiltering && !loading && searchControl.value && !isSearchPage) {
    <div @slideDownUp class="search-results" >
      <div class="search-results-inner">
        <app-global-search-results [isSmallMode]="true"></app-global-search-results>
      </div>
    </div>
  }
</div>
